<ng-container coreActivitySection="Rewards">
  @let currentLanguage = this.currentLanguage();
  @let isFrench = currentLanguage === 'fr-CA';

  <app-page-header
    class="header"
    (click)="back.emit()"
    coreUserActivityClickTracking="CloseRewards"
    [backSwipe]="backSwipeConfig"
  />

  <div class="content">
    @if (isFrench) {
      <img
        src="/images/service-center-sections/rewards-content-fr.svg"
        width="502"
        height="642"
        alt="Rewards Content"
      />
    } @else {
      <img
        src="/images/service-center-sections/rewards-content-en.svg"
        width="643"
        height="642"
        alt="Rewards Content"
      />
    }
  </div>

  <div class="link">
    @let qrCodeLinkEn = 'https://oon.gl/QLB6Kc';
    @let qrCodeLinkFr = 'https://oon.gl/T7m9t2';

    <app-qrcode
      class="qr-code"
      variant="blue"
      [content]="isFrench ? qrCodeLinkFr : qrCodeLinkEn"
      [size]="400"
    />
  </div>
</ng-container>
